import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 500.000000 500.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,500.000000) scale(0.100000,-0.100000)"
        >
          <path
            d="M1468 3399 c-173 -25 -386 -128 -510 -247 -47 -45 -58 -61 -58 -87 0
-18 8 -39 18 -48 35 -32 69 -21 155 49 199 159 437 225 681 189 188 -28 319
-89 457 -211 56 -49 103 -58 132 -26 33 36 22 75 -35 129 -135 127 -331 221
-528 252 -75 12 -229 12 -312 0z"
          />
          <path
            d="M1460 3104 c-95 -20 -235 -95 -303 -161 -65 -63 -71 -90 -31 -129 33
-34 57 -27 137 35 34 27 85 60 112 73 115 58 271 73 400 39 87 -22 135 -47
220 -111 84 -64 106 -70 139 -36 38 37 33 67 -16 114 -104 98 -209 153 -346
181 -71 15 -232 12 -312 -5z"
          />
          <path
            d="M1485 2812 c-70 -30 -105 -52 -146 -91 -41 -41 -46 -58 -28 -94 26
-49 70 -50 134 -1 111 85 248 86 364 3 62 -45 102 -50 125 -17 42 59 2 118
-122 179 -62 31 -75 34 -177 36 -86 1 -119 -2 -150 -15z"
          />
          <path
            d="M2987 2474 c-18 -19 -5 -34 29 -34 28 0 35 3 32 18 -3 17 -48 29 -61
16z"
          />
          <path
            d="M3097 2473 c-3 -5 -5 -58 -4 -119 l2 -109 30 0 30 0 0 115 0 115 -27
3 c-14 2 -28 -1 -31 -5z"
          />
          <path d="M3200 2360 l0 -120 34 0 35 0 0 120 0 120 -35 0 -34 0 0 -120z" />
          <path
            d="M2730 2355 l0 -115 78 0 c42 0 88 6 102 13 31 16 39 61 14 88 -16 18
-16 20 1 39 23 26 13 68 -21 80 -14 6 -59 10 -100 10 l-74 0 0 -115z m140 45
c0 -16 -7 -20 -35 -20 -28 0 -35 4 -35 20 0 16 7 20 35 20 28 0 35 -4 35 -20z
m-12 -69 c6 0 12 -10 12 -21 0 -16 -7 -20 -35 -20 -30 0 -35 3 -35 24 0 18 5
23 23 21 12 -1 28 -3 35 -4z"
          />
          <path
            d="M2984 2407 c-3 -8 -4 -47 -2 -88 l3 -74 30 0 c30 0 30 0 33 65 4 88
-2 110 -34 110 -13 0 -27 -6 -30 -13z"
          />
          <path
            d="M3348 2404 c-31 -16 -41 -44 -36 -95 2 -28 10 -37 41 -53 56 -27 137
-5 137 38 0 16 -45 15 -62 -1 -18 -19 -46 -16 -58 7 -10 19 -8 20 55 20 57 0
65 2 65 19 0 33 -11 51 -41 66 -35 19 -66 18 -101 -1z m80 -41 c2 -9 -7 -13
-27 -13 -30 0 -39 9 -24 24 11 10 46 3 51 -11z"
          />
          <path
            d="M3530 2330 l0 -90 30 0 c28 0 30 2 30 41 0 50 15 79 40 79 14 0 20 7
20 23 0 32 -8 37 -38 26 -18 -7 -28 -7 -30 0 -2 6 -15 11 -28 11 -24 0 -24 -1
-24 -90z"
          />
        </g>
      </svg>
    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>;
}
